<template>
  <el-dialog :title="'新增成员'" :visible.sync="open" :center="true" width="513px" @close="cancel" :close-on-click-modal="false">
    <div>
      <el-input v-model="query.keyWord" suffix-icon="el-icon-search" @change="inputChange" placeholder="输入工号/姓名/部门搜索成员"></el-input>
    </div>
    <div class="select-dialog">
      <div class="left-div border1-right width50">
        <el-tree :data="STATIC_DeptTrees" :props="defaultProps" @node-click="handleNodeClick" accordion node-key="id" :render-content="renderContent"></el-tree>
      </div>
      <div class="right-div">
        <el-checkbox-group v-model="userIdChecked" @change="change">
          <el-checkbox v-for="user in userList" :label="user.id" :key="user.id" style="display: block">{{ user.no + " " + user.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="selected-div">
      <template v-for="item in userChecked">
        <div :key="item.id" class="value">
          <span>{{ item.no + " " + item.name + " " }}
            <i class="el-icon-close" style="cursor: pointer;" v-preventReClick @click="removeItem(item)" />
          </span>
        </div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { GetUserList } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  name: "myCheckBox",
  mixins: [GetDataMixin],
  data () {
    return {
      userChecked: [],
      userIdChecked: [],
      // deptList: [],
      userList: [],
      open: false,
      // keyWord: '',
      defaultProps: {
        children: "children",
        label: "name",
      },
      query: {
        pageIndex: 1,
        pageSize: 15,
        keyWord: "",
        deptId: "",
      },
      defaultCheckedKeys: [],
    };
  },
  props: {
    oldData: {
      type: Array,
      default () {
        return [];
      },
    },
    show: {
      type: Boolean,
      default () {
        return false;
      },
    },
  },
  created () {
    this.getDeptTrees();
  },
  watch: {
    show (val, oldVal) {
      this.open = val;
      this.userChecked = JSON.parse(JSON.stringify(this.oldData));
      this.userIdChecked = this.userChecked.map((i) => i.id);

      this.query.keyWord = "";
      this.getDeptTrees();
      this.userList = [];
    },
  },
  methods: {
    renderContent (h, { node, data, store }) {
      return (
        // <el-tooltip class="item" effect="dark" placement="bottom-start">
        // <div slot="content">{data.no + ' ' + data.name}</div>
        <span class="custom-tree-node" style="overflow:hidden;">
          <span>{data.no + " " + data.name}</span>
        </span>
        // </el-tooltip>
      );
    },
    handleNodeClick (node) {
      this.query.deptId = node.id;
      this.getUserList();
    },
    cancel () {
      // this.$my_confirm('确认要中断当前操作吗？', '提示', {
      //   type: 'warning'
      // })
      //   .then(() => {
      this.open = false;
      this.$emit("close");
      // })
    },
    submit () {
      this.open = false;
      this.$emit("getData", this.userChecked);
    },
    removeItem (data) {
      this.userChecked = this.userChecked.filter((i) => i.id != data.id);
      this.userIdChecked = this.userChecked.map((i) => i.id);
    },
    inputChange () {
      // this.$emit('filterMethod', val);
      if (this.query.keyWord) {
        this.STATIC_DeptTrees = [];
        this.query.deptId = "";
        this.getUserList();
      } else {
        this.getDeptTrees();
        this.userList = [];
      }
    },
    change (val) {
      if (val && val.length > 0) {
        let isAdd = false;

        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          let item = this.userChecked.find((e) => e.id == val[i]);
          if (item == null) {
            isAdd = true;
            let obj = this.userList.find((e) => e.id == val[i]);
            if (obj) {
              this.userChecked.push(obj);
            }
            break;
          }
        }

        // 删除
        if (!isAdd) {
          this.userChecked = this.userChecked.filter(
            (i) => val.indexOf(i.id) != -1
          );
        }
      } else {
        this.userChecked = [];
      }
    },
    getUserList () {
      GetUserList(this.query).then((res) => {
        this.userList = res.returnData.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>
